import { useEffect } from 'react';
import { Outlet, useOutlet } from 'react-router-dom';
import PageMenu from '../PageMenu/PageMenu';

type Props = {};

export default function Welcome({}: Props) {
	const outlet = useOutlet();

	useEffect(() => {
		const urlPrefix: string =
			'https://ph4sm4-content.s3.eu-central-1.amazonaws.com';

		const sound = new Audio(urlPrefix + '/media/fortnite_winter_music_1h.mp3'); // Make sure file is in /public folder

		const handler = () => {
			sound.play();
			window.removeEventListener('click', handler);
		};

		window.addEventListener('click', handler);
		console.log('adding listener');

		return () => {
			window.removeEventListener('click', handler);
			sound.pause();
		};
	}, []);

	return (
		<main className="text-white w-[80%] mx-auto p-8 flex flex-col gap-10 mt-52 mb-20">
			<h1 className="text-3xl text-center font-medium">
				Wesołych Świąt Bożego Narodzenia, wprawdzie bez śniegu, ale chociaż dziś
				trochę przymroziło :)
			</h1>
			<iframe
				src="https://giphy.com/embed/vqtXeZnySYn90g3kQU"
				width="100%"
				height="100%"
				className="pointer-events-none w-[50vw] h-[50vh] mx-auto"></iframe>

			<PageMenu
				className="mx-auto text-2xl"
				items={[
					{
						displayName: 'Dziadek i Babcia',
						link: '/christmas-2025/content/babcia-dziadek'
					},
					{
						displayName: 'Tata',
						link: '/christmas-2025/content/tata'
					},
					{
						displayName: 'Laura i Iwo',
						link: '/christmas-2025/content/laura-iwo'
					}
				]}
			/>

			{outlet && (
				<div className="w-4/5 mx-auto shadow-lg shadow-gray-600/50 px-10 py-5 rounded-lg">
					<Outlet />
				</div>
			)}
		</main>
	);
}
